import { FormattedMessage } from 'react-intl';
import Button from './core/Button';
import { IconEdit } from '@/icons';

interface Props {
  onClickButton: () => void;
}

export const EditButton = ({ onClickButton }: Props) => {
  return (
    <Button startIcon={<IconEdit />} variant="ghost" onClick={onClickButton}>
      <FormattedMessage defaultMessage="Redigera" />
    </Button>
  );
};
